<template>
    <!-- Główny kontener, zawierający sekcję filtrów i wyniki -->
    <div class="content">
      <div class="ds-toolbar">
        <label class="ds-switch" for="calibration-deviation-location-view-toggle" v-if="step === 1">
          <span class="ds-switch__label">{{ t('map').toUpperCase() }}</span>
          <input id="calibration-deviation-location-view-toggle" type="checkbox" v-model="useMapLocationList" />
          <span class="ds-switch__track"></span>
        </label>
      </div>
      <div class="d-flex filters">
             <!-- Krok 1: komponent filtrów wyświetlany, gdy step === 1 -->
      <FilterCalibrationComponent
        v-if="step === 1"
        :from="'calibration-deviation'"
        :use-map-location-list="useMapLocationList"
      />
      <!-- Krok 2: wyniki wyświetlane, gdy step !== 1 -->
      <div v-else class="results">
        <!-- Jeżeli mamy jakieś wyniki -->
        <div v-if="results && results.length">
          <!-- Iteracja po każdej lokalizacji w wynikach -->
          <div
            v-for="(locBlock) in results"
            :key="locBlock.location.id"
            class="location-block"
          >
            <!-- Nazwa lokalizacji -->
            <h3>{{ locBlock.location.shortName }}</h3>

            <!-- Iteracja po każdym pasie w danej lokalizacji -->
            <div
              v-for="(laneBlock) in locBlock.lanes"
              :key="laneBlock.lane.id"
              class="lane-block"
            >
              <!-- Numer pasa -->
              <!-- <h4>Pas {{ laneBlock.lane.laneNumber }}</h4> -->

              <!-- TU wykres dla tego pasa -->
              <div class="calibration-graph" v-if="laneBlock.graphBase64">
                <img
                  :src="`data:image/png;base64,${laneBlock.graphBase64}`"
                  :alt="t('calibration-lane-chart')"
                  style="max-width:100%; margin-bottom:1rem;"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Komunikat, gdy brak wyników -->
        <p v-else>{{ t('no-matches') }}</p>
      </div>
      </div>

      <!-- Pasek akcji kreatora: Wstecz / Zastosuj — te same klasy co w pozostałych
           kreatorach (bieżący pomiar, archiwum, statystyki, kalibracja). -->
      <div class="ds-toolbar ds-toolbar--footer actions">
        <!-- Przycisk "Cofnij" widoczny, gdy step !== 1 -->
        <button
          class="ds-btn ds-btn--secondary btn-prev"
          v-if="step !== 1"
          @click="back()"
        >
          <span class="ds-btn__arrow" aria-hidden="true">&#8592;</span>
          <span>{{ t('back2').toUpperCase() }}</span>
        </button>

        <div class="ds-toolbar__spacer"></div>

        <!-- Przycisk "Zastosuj" widoczny, gdy step === 1 -->
        <button
          class="ds-btn ds-btn--primary btn-next"
          v-if="step === 1"
          @click="apply()"
        >
          {{ t('apply').toUpperCase() }}
          <span class="ds-btn__arrow" aria-hidden="true">&#8594;</span>
        </button>
      </div>
    </div>
</template>
  
  <script>
  import moment from "moment";                           // biblioteka do formatowania daty
  import FilterCalibrationComponent from "./FilterCalibrationComponent";  // komponent filtrów
  import CalibrationsService from "@/services/CalibrationsService";      // serwis pobierający dane
  
  // Ustawienie polskiej lokalizacji dla moment.js
  moment.locale("pl");
  
  export default {
    name: "CalibrationDeviation",  // nazwa komponentu
    components: { FilterCalibrationComponent },
    data() {
      return {
        step: 1,       // aktualny krok: 1 = filtr, 2 = wyniki
        results: null, // tu trzymamy dane pobrane z serwisu
        useMapLocationList: false,
      };
    },
    methods: {
      /**
       * Wywoływane po kliknięciu "Zastosuj" w kroku 1.
       * Pobiera dane i przechodzi do kroku 2.
       */
      apply() {
        CalibrationsService.getCalibrationsDeviation()
          .then((response) => {
            this.results = response; // zapis odpowiedzi
            this.step = 2;           // przejście do kroku 2
          })
          .catch((error) => {
            console.error("Error fetching calibrations:", error);
          });
      },
      /**
       * Wywoływane po kliknięciu "Cofnij" w kroku 2.
       * Czyści wyniki i wraca do kroku 1.
       */
      back() {
        this.step = 1;
        this.results = null;
      },
      /**
       * Formatowanie daty na format 'DD.MM.YYYY HH:mm'.
       */
      formatDate(dt) {
        return moment(dt).format("DD.MM.YYYY HH:mm");
      },
      /**
       * Alias do tłumaczeń (vue-i18n): zwraca przetłumaczony tekst.
       */
      t(key) {
        return this.$t(key);
      },
    },
  };
  </script>
  
  <style scoped>
  /* Styl głównego kontenera */
  .content {
    width: 100%;
    min-height: 270px;
    margin-bottom: 20px;
  }
  /* Pasek narzędzi zostaje widoczny także w kroku wyników (bez przełącznika mapy),
     żeby trzymał kreskę i wysokość taką samą jak w pozostałych widokach. */
  .ds-toolbar {
    min-height: calc(var(--control-height) + 2 * var(--spacing-sm));
  }

  /* Sekcja filtrów/wyników leży między paskiem narzędzi a paskiem akcji — kreski
     rysują paski (`ds-toolbar`), więc tutaj nie dokładamy własnych. */
  /* Styl sekcji wyników */
  .results {
    width: 100%;
    padding: 1rem;
    background: var(--surface-secondary);
    border-radius: 4px;
    font-family: monospace;
    font-size: 0.9rem;
  }
  
  /* Paski akcji i przyciski w całości z systemu (`ds-toolbar`, `ds-btn`) —
     bez lokalnych nadpisań. */

  /* Podświetlenie wiersza, gdy dewiacja > 7 */
  .red td {
    background-color: var(--status-error-soft) !important;
  }
  </style>
